<template>
  <div class="testPaper">
    <div class="testPaperWrap">
      <div class="left">
        <div class="header">
          <div class="title">{{ detail.paperTitle }}</div>
          <div class="testDetail">
            <span>试题数量：{{ detail.questionTotal }}道</span>
            <span>满分：{{ detail.fullScore }}分</span>
          </div>
        </div>
        <div class="footer">
          <el-button v-if="num !== 0" class="signListUp" @click="preBtn">上一题</el-button>
          <el-button v-if="submit && !submitPaper" class="signListNext" @click="oneQuestionSumit"
            >提交</el-button
          >
          <el-button v-if="num + 1 !== list.length && !submit" class="signListNext" @click="nextBtn"
            >下一题</el-button
          >
          <el-button
            v-if="num + 1 == list.length && submitPaper"
            class="signListNext"
            @click="submitPaperFn"
            >交卷</el-button
          >
        </div>
        <div class="quertionWrap">
          <component
            :is="questionComponentMap[list[num].questionType - 1]"
            :data="list[num]"
            :num="num"
            :all-arr="detail.questionList"
          ></component>
          <div v-if="list[num].showAnswer">
            <div
              v-if="
                list[num].questionType == 1 ||
                  list[num].questionType == 2 ||
                  list[num].questionType == 4
              "
              class="itemUserBox"
            >
              <div class="flexBox">
                <div class="itemOne">
                  正确答案<span
                    v-for="(v, index) in list[num].rightAnswer"
                    :key="index"
                    class="itemTwo"
                    >{{ v }}</span
                  >
                </div>
                <div class="itemOne">
                  考生答案<span
                    v-for="(v, index) in list[num].userAnswer"
                    :key="index"
                    class="itemThr"
                    >{{ v }}</span
                  >
                </div>
              </div>
            </div>
            <div v-else class="blanksQues">
              <div class="UserAnwserBox">
                <div style="display:flex">
                  <div class="subtitle">【考生答案】</div>
                </div>
                <div
                  v-for="(v, index) in list[num].userAnswer"
                  :key="index"
                  style="display:flex;margin-top:20px"
                >
                  <div v-if="list[num].questionType == 5" class="textitle">
                    填空{{ ['一', '二', '三', '四', '五', '六', '七'][index] }}：
                  </div>
                  <!-- eslint-disable-next-line vue/no-v-html -->
                  <div class="text" v-html="v"></div>
                </div>
              </div>
              <div class="SystemAnwserBox">
                <div class="subtitle">【标准答案】</div>
                <div
                  v-for="(v, index) in list[num].rightAnswer"
                  :key="index"
                  style="display:flex;margin-top:20px"
                >
                  <div v-if="list[num].questionType == 5" class="textitle">
                    填空{{ ['一', '二', '三', '四', '五', '六', '七'][index] }}：
                  </div>
                  <!-- eslint-disable-next-line vue/no-v-html -->
                  <div class="text" v-html="v"></div>
                </div>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <!-- <div class="text" v-html="item.rightAnswer"></div> -->
              </div>
            </div>
          </div>
          <template v-if="isRootUser">
            <div class="block">
              <el-dialog
                title="添加"
                :visible.sync="insertAnsDialog"
                :close-on-click-modal="false"
                width="835px"
              >
                <el-form label-width="80px">
                  <el-form-item label="最低分">
                    <el-input v-model="ansForm.low"></el-input>
                  </el-form-item>
                  <el-form-item label="最高分">
                    <el-input v-model="ansForm.high"></el-input>
                  </el-form-item>
                  <el-form-item label="答案">
                    <tinymce ref="editor" v-model="ansForm.ans" height="320" width="713"></tinymce>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="insertAnsSubmit()">保存</el-button>
                  <el-button @click="insertAnsDialog = false">取消</el-button>
                </span>
              </el-dialog>
              <el-button class="addAns" @click="handleInsertAns">添加答案</el-button>
            </div>
            <el-table :data="ansList" style="width: 100%">
              <el-table-column prop="ans" label="答案" show-overflow-tooltip> </el-table-column>
              <el-table-column prop="low" label="最低分" width="90"> </el-table-column>
              <el-table-column prop="high" label="最高分" width="90"> </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
      <div class="right">
        <div class="rightContent">
          <div v-if="single.length > 0" class="testBox">
            <div class="testType">单选题</div>
            <div
              v-for="(item, index) in single"
              :key="index"
              class="choiceItem"
              :class="[
                { nowActive: num == index },
                {
                  choiceActive:
                    item[['signListRadio', '', '', 'judgeListRadio'][item.questionType - 1]] !== '',
                },
              ]"
              @click="answerCard(index)"
            >
              {{ index + 1 }}
            </div>
          </div>
          <div v-if="multiple.length > 0" class="testBox">
            <div class="testType">多选题</div>
            <div
              v-for="(item, index) in multiple"
              :key="index"
              class="choiceItem"
              :class="[
                { nowActive: num == index + single.length },
                {
                  choiceActive: item.checkbox.length !== 0,
                },
              ]"
              @click="answerCard(index + single.length)"
            >
              {{ index + 1 + single.length }}
            </div>
          </div>
          <div v-if="calculation.length > 0" class="testBox">
            <div class="testType">计算题</div>
            <div
              v-for="(item, index) in calculation"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive: num == index + single.length + multiple.length,
                },
                {
                  choiceActive:
                    item.optionList.filter(v => v.answer).length == item.optionList.length,
                },
              ]"
              @click="answerCard(index + single.length + multiple.length)"
            >
              {{ index + 1 + single.length + multiple.length }}
            </div>
          </div>
          <div v-if="judgeList.length > 0" class="testBox">
            <div class="testType">判断题</div>
            <div
              v-for="(item, index) in judgeList"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive: num == index + single.length + multiple.length + calculation.length,
                },
                {
                  choiceActive:
                    item[['signListRadio', '', '', 'judgeListRadio'][item.questionType - 1]] !== '',
                },
              ]"
              @click="answerCard(index + single.length + multiple.length + calculation.length)"
            >
              {{ index + 1 + single.length + multiple.length + calculation.length }}
            </div>
          </div>
          <div v-if="completion.length > 0" class="testBox">
            <div class="testType">填空题</div>
            <div
              v-for="(item, index) in completion"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index + single.length + multiple.length + calculation.length + judgeList.length,
                },
                {
                  choiceActive:
                    item.optionList.filter(v => v.answer).length == item.optionList.length,
                },
              ]"
              @click="
                answerCard(
                  index + single.length + multiple.length + calculation.length + judgeList.length,
                )
              "
            >
              {{
                index + 1 + single.length + multiple.length + calculation.length + judgeList.length
              }}
            </div>
          </div>
          <div v-if="shortAnswer.length > 0" class="testBox">
            <div class="testType">简答题</div>
            <div
              v-for="(item, index) in shortAnswer"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index +
                      single.length +
                      multiple.length +
                      calculation.length +
                      judgeList.length +
                      completion.length,
                },
                {
                  choiceActive:
                    item.optionList.filter(v => v.answer).length == item.optionList.length,
                },
              ]"
              @click="
                answerCard(
                  index +
                    single.length +
                    multiple.length +
                    calculation.length +
                    judgeList.length +
                    completion.length,
                )
              "
            >
              {{
                index +
                  1 +
                  single.length +
                  multiple.length +
                  calculation.length +
                  judgeList.length +
                  completion.length
              }}
            </div>
          </div>
          <div v-if="discuss.length > 0" class="testBox">
            <div class="testType">论述题</div>
            <div
              v-for="(item, index) in discuss"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index +
                      single.length +
                      multiple.length +
                      calculation.length +
                      judgeList.length +
                      completion.length +
                      shortAnswer.length,
                },
                {
                  choiceActive:
                    item.optionList.filter(v => v.answer).length == item.optionList.length,
                },
              ]"
              @click="
                answerCard(
                  index +
                    single.length +
                    multiple.length +
                    calculation.length +
                    judgeList.length +
                    completion.length +
                    shortAnswer.length,
                )
              "
            >
              {{
                index +
                  1 +
                  single.length +
                  multiple.length +
                  calculation.length +
                  judgeList.length +
                  completion.length +
                  shortAnswer.length
              }}
            </div>
          </div>
          <div v-if="caseAnalysis.length > 0" class="testBox">
            <div class="testType">案列分析题</div>
            <div
              v-for="(item, index) in caseAnalysis"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index +
                      single.length +
                      multiple.length +
                      calculation.length +
                      judgeList.length +
                      completion.length +
                      shortAnswer.length +
                      discuss.length,
                },
                {
                  choiceActive:
                    item.optionList.filter(v => v.answer).length == item.optionList.length,
                },
              ]"
              @click="
                answerCard(
                  index +
                    single.length +
                    multiple.length +
                    calculation.length +
                    judgeList.length +
                    completion.length +
                    shortAnswer.length +
                    discuss.length,
                )
              "
            >
              {{
                index +
                  1 +
                  single.length +
                  multiple.length +
                  calculation.length +
                  judgeList.length +
                  completion.length +
                  shortAnswer.length +
                  discuss.length
              }}
            </div>
          </div>
          <div v-if="comprehensive.length > 0" class="testBox">
            <div class="testType">综合题</div>
            <div
              v-for="(item, index) in comprehensive"
              :key="index"
              class="choiceItem"
              :class="[
                {
                  nowActive:
                    num ==
                    index +
                      single.length +
                      multiple.length +
                      calculation.length +
                      judgeList.length +
                      completion.length +
                      shortAnswer.length +
                      discuss.length +
                      caseAnalysis.length,
                },
                {
                  choiceActive:
                    item.optionList.filter(v => v.answer).length == item.optionList.length,
                },
              ]"
              @click="
                answerCard(
                  index +
                    single.length +
                    multiple.length +
                    calculation.length +
                    judgeList.length +
                    completion.length +
                    shortAnswer.length +
                    discuss.length +
                    caseAnalysis.length,
                )
              "
            >
              {{
                index +
                  1 +
                  single.length +
                  multiple.length +
                  calculation.length +
                  judgeList.length +
                  completion.length +
                  shortAnswer.length +
                  discuss.length +
                  caseAnalysis.length
              }}
            </div>
          </div>
        </div>
        <div class="rightFooter">
          <div class="submitBtn" @click="submitPaperFn">交卷</div>
        </div>
      </div>
    </div>
    <el-dialog
      title="确认交卷"
      :visible.sync="surplusDialog"
      :close-on-click-modal="false"
      class="delDia"
      width="400px"
    >
      <span v-if="content !== 0">还有{{ content }}道题未做完，您确定要交卷吗？</span>
      <span v-if="content == 0">您确定要交卷吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureDialogSubmit()">确认交卷</el-button>
        <el-button @click="surplusDialog = false">继续答题</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { testPaperData } from '@/api/exam'
import { paperAnsAdd, paperAnsList } from '@/api/system'
import to from 'await-to'
import { mapGetters } from 'vuex'
import Single from './testComponents/Single'
import Multiple from './testComponents/Multiple'
import ShortAnswer from './testComponents/ShortAnswer'
import Completion from './testComponents/Completion'
import Tinymce from '@/components/Tinymce'
export default {
  components: {
    Single,
    Multiple,
    ShortAnswer,
    Completion,
    Tinymce,
  },
  data() {
    return {
      rootID: process.env.VUE_APP_ROOT_USERID,
      // rootID: 74,
      list: [{}],
      detail: {},
      single: [], //单选1
      multiple: [], //多选2
      calculation: [], //计算3
      judgeList: [], //判断4
      completion: [], //填空5
      shortAnswer: [], //简答6
      discuss: [], //论述7
      caseAnalysis: [], //案例分析8
      comprehensive: [], //综合
      num: 0,
      submit: true,
      submitPaper: false,
      questionComponentMap: [
        'Single',
        'Multiple',
        'ShortAnswer',
        'Single',
        'Completion',
        'ShortAnswer',
        'ShortAnswer',
        'ShortAnswer',
        'ShortAnswer',
      ],
      surplusDialog: false,
      content: 0,
      insertAnsDialog: false,
      ansForm: {},
      ansList: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isRootUser() {
      return JSON.parse(this.rootID).includes(this.userInfo.id) && sessionStorage.getItem('rootUserSwitch') === '1'
    },
  },
  watch: {
    num() {
      if (this.isRootUser) this.getAnsList()
    },
  },
  async mounted() {
    await this.getQuestionData()
    if (this.isRootUser) this.getAnsList()
  },
  methods: {
    async getQuestionData() {
      const { id } = this.$route.query
      const [res, err] = await to(testPaperData({ examPaperId: id }))
      if (err) return this.$message.warning(err.msg)
      this.detail = res.data
      res.data.questionList.forEach(element => {
        this.$set(element, 'userAnswer', [])
        this.$set(element, 'rightAnswer', [])
        this.$set(element, 'showAnswer', false)
      })
      this.single = res.data.questionList.filter(item => {
        this.$set(item, 'signListRadio', '')
        return item.questionType == 1
      })
      this.multiple = res.data.questionList.filter(item => {
        this.$set(item, 'checkbox', [])
        return item.questionType == 2
      })
      this.calculation = res.data.questionList.filter(item => {
        return item.questionType == 3
      })
      this.judgeList = res.data.questionList.filter(item => {
        this.$set(item, 'judgeListRadio', '')
        return item.questionType == 4
      })
      this.completion = res.data.questionList.filter(item => {
        return item.questionType == 5
      })
      this.shortAnswer = res.data.questionList.filter(item => {
        return item.questionType == 6
      })
      this.discuss = res.data.questionList.filter(item => {
        return item.questionType == 7
      })
      this.caseAnalysis = res.data.questionList.filter(item => {
        return item.questionType == 8
      })
      this.comprehensive = res.data.questionList.filter(item => {
        return item.questionType == 9
      })
      this.list = [
        ...this.single,
        ...this.multiple,
        ...this.calculation,
        ...this.judgeList,
        ...this.completion,
        ...this.shortAnswer,
        ...this.discuss,
        ...this.caseAnalysis,
        ...this.comprehensive,
      ]
    },
    oneQuestionSumit() {
      var item = this.list[this.num]
      this.$set(item, 'userAnswer', [])
      this.$set(item, 'rightAnswer', [])
      var obj = {
        1: 'signListRadio',
        2: 'checkbox',
        4: 'judgeListRadio',
      }
      var answerList = []
      if (item.questionType == 1 || item.questionType == 2 || item.questionType == 4) {
        if (item.questionType == 1 || item.questionType == 4) {
          answerList = [{ answer: '', optionId: item[obj[item.questionType]] }]
        } else if (item.questionType == 2) {
          item.checkbox.map(v => {
            answerList.push({
              answer: '',
              optionId: v,
            })
          })
        }
        item.optionList.forEach(element => {
          answerList.forEach(v => {
            if (element.optionId == v.optionId) {
              if (item.questionType == 4) {
                item.userAnswer.push(element.optionName)
              } else {
                item.userAnswer.push(element.optionTag)
              }
            }
          })
          if (element.rightKey == 1) {
            if (item.questionType == 4) {
              item.rightAnswer.push(element.optionName)
            } else {
              item.rightAnswer.push(element.optionTag)
            }
          }
        })
      } else {
        item.optionList.map(v => {
          answerList.push({
            answer: v.answer,
            optionId: v.optionId,
          })
        })
        answerList.forEach(v => {
          item.userAnswer.push(v.answer)
        })
        item.optionList.forEach(element => {
          item.rightAnswer.push(element.optionName)
        })
      }
      item.showAnswer = true
      this.submit = false
      if (this.num == this.list.length - 1) {
        this.submitPaper = true
      }
    },
    preBtn() {
      this.num -= 1
      this.submit = true
      this.submitPaper = false
    },
    nextBtn() {
      this.num += 1
      this.submit = true
    },
    submitPaperFn() {
      let arry = []
      for (var i = 0; i < this.list.length; i++) {
        var item = this.list[i]
        if (item.showAnswer) arry.push(item)
      }
      this.content = this.list.length - arry.length
      this.surplusDialog = true
    },
    sureDialogSubmit() {
      this.$router.push({ path: '/exam/paper' })
    },
    answerCard(v) {
      this.num = v
    },
    handleInsertAns() {
      this.insertAnsDialog = true
    },
    async insertAnsSubmit() {
      var item = this.list[this.num]
      const { id } = this.$route.query
      const [, err] = await to(
        paperAnsAdd({ paperId: id, questionId: item.questionId, ...this.ansForm }),
      )
      if (err) return this.$message.warning(err.msg)
      this.insertAnsDialog = false
      this.ansForm = {}
      this.getAnsList()
    },
    async getAnsList() {
      var item = this.list[this.num]
      console.log(`output->item`, item)
      const { id } = this.$route.query
      const [res, err] = await to(paperAnsList({ paperId: id, questionId: item.questionId }))
      if (err) return this.$message.warning(err.msg)
      this.ansList = res.data
    },
  },
}
</script>
<style lang="scss">
.el-tooltip__popper {
  max-width: 800px;
}
</style>
<style scoped lang="scss">
.block {
  margin-top: 20px;
  .el-button.addAns {
    width: 100%;
  }
}
.testPaper {
  height: 100vh;
  background-color: #f5f7fa;
  .choiceActive {
    background-color: #e6effa !important;
    color: #3671bf !important;
  }
  .testPaperWrap {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    .left {
      width: 880px;
      margin-right: 30px;
      background-color: #fff;
      position: relative;
      .header {
        padding-top: 20px;
        box-sizing: border-box;
        height: 110px;
        text-align: center;
        border-bottom: 1px solid #e8ebf2;
        .title {
          font-size: 30px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #333333;
        }
        .testDetail {
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #909399;
          span {
            display: inline-block;
            margin: 10px 50px 0;
          }
        }
      }
      .footer {
        z-index: 99;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 880px;
        height: 60px;
        background: #ffffff;
        box-shadow: 0px -2px 10px 1px #e7ebf2;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-button {
          width: 100px;
        }
        .signListNext {
          background-color: #3671bf;
          color: #fff;
        }
        .signListUp {
          margin-right: 40px;
          border: 1px solid #3671bf;
          color: #3671bf;
        }
      }
      .quertionWrap {
        height: calc(100% - 110px);
        overflow: auto;
        padding: 30px 30px 80px;
        box-sizing: border-box;
        .itemUserBox {
          margin-top: 40px;
          height: 50px;
          background: #f5f8fc;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          .flexBox {
            width: 340px;
            display: flex;
            justify-content: space-between;
            padding-left: 20px;
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            line-height: 50px;
            .itemOne {
              color: #808080;
            }
            .itemTwo {
              margin-left: 14px;
              color: #45bb6d;
            }
            .itemThr {
              margin-left: 14px;
              color: #3671bf;
            }
            .itemFou {
              color: #ff3b3a;
            }
            .itemFiv {
              color: #45bb6d;
            }
          }
        }
        .blanksQues {
          margin-top: 40px;
          .UserAnwserBox {
            background: #f5f8fc;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            border: 1px solid #e4eaf2;
            padding: 20px 30px;
            .subtitle {
              font-size: 16px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #3671bf;
              line-height: 30px;
            }
            .textitle {
              font-size: 16px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #666666;
              line-height: 20px;
              margin-right: 20px;
            }
            .text {
              font-size: 16px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #666666;
            }
          }
          .SystemAnwserBox {
            margin-top: 16px;
            background: #f7fcf9;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            border: 1px solid #e4eaec;
            padding: 20px 30px;
            .subtitle {
              font-size: 16px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #45bb6d;
              line-height: 16px;
            }
            .textitle {
              font-size: 16px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #666666;
              line-height: 20px;
              margin-right: 20px;
            }
            .text {
              font-size: 16px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #666666;
              line-height: 16px;
            }
          }
        }
      }
    }
    .right {
      width: 290px;
      height: 610px;
      overflow-y: auto;
      background-color: #fff;
      .nowActive {
        background-color: #3671bf !important;
        color: #fff !important;
      }
      .rightContent {
        height: calc(100% - 75px);
        overflow-x: hidden;
        overflow-y: auto;
        padding: 20px 0;
        box-sizing: border-box;
        .testBox {
          overflow: hidden;
          .testType {
            margin-left: 20px;
            padding-left: 8px;
            box-sizing: border-box;
            font-size: 16px;
            margin-bottom: 20px;
            color: #666;
            position: relative;
            &::before {
              content: '';
              width: 3px;
              height: 16px;
              background-color: #3179e4;
              margin-right: 5px;
              position: absolute;
              left: 0;
              top: 5px;
            }
          }
        }
        .choiceItem {
          width: 36px;
          line-height: 28px;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid #e6e8ed;
          text-align: center;
          float: left;
          cursor: pointer;
          margin-left: 16px;
          margin-bottom: 16px;
        }
      }
      .rightFooter {
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        .submitBtn {
          width: 160px;
          line-height: 40px;
          background: #3671bf;
          border-radius: 4px 4px 4px 4px;
          color: #fff;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
    .el-dialog__body {
      flex: 1;
      overflow: auto;
      text-align: center;
    }
    .el-dialog__header {
      background: #fafcff;
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #4d4d4d;
      border-bottom: 1px solid #e6ecf5;
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
      .el-button {
        width: 100px;
        height: 36px;
        border-radius: 4px 4px 4px 4px;
        padding: 0;
      }
    }
    .el-button--primary {
      background: #3671bf;
      border-color: #3671bf;
    }
    .el-button--default {
      margin-left: 30px;
    }
  }
}
</style>
